import React, { Component } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import Button from '../../components/form/Button';
import ViewHeader from '../../components/header/ViewHeader';
import FilterModal from './Modals/FilterModal';
import DataTable from '../../components/dataTable/DataTable';
import EnquiryFragment from '../../fragments/Enquiry';
import {
    joinDefined,
    PAGE_CREMATIONS,
    PAGE_ENQUIRIES,
    PAGE_PLAQUES,
    prettyPhone,
    prettyPrice
} from '../../utils/strings';
import { niceTimeFromString, shortDateFromString } from '../../utils/date';
import ErrorFallback from '../../components/ErrorFallback';
import { withErrorBoundary } from '@sentry/react';
import moment from 'moment';

class EnquiryListing extends Component {
    state = {
        showFilterModal: false
    };

    render() {
        const { showFilterModal } = this.state;

        return (
            <Grid container className="sticky-table">
                <Grid item>{this.renderHeader()}</Grid>
                <Grid item>
                    <Paper elevation={0}>
                        <Grid item>{this.renderEnquiryListingsTable()}</Grid>
                    </Paper>
                </Grid>
                <FilterModal
                    open={!!showFilterModal}
                    anchorEl={showFilterModal}
                    onClose={() => this.setState({ showFilterModal: false })}
                />
            </Grid>
        );
    }

    renderHeader() {
        return <ViewHeader title="Bookings" />;
    }

    renderEnquiryListingsTable() {
        return (
            <Grid container>
                <Grid item>
                    <DataTable
                        queryName="readCMEnquiries"
                        dataObject="CMEnquiry"
                        fragment={EnquiryFragment}
                        isFilterable
                        isSortable
                        columns={enquiryColumns}
                        variables={{ filterBy: [] }}
                        // brandProperty="LegacyKey"
                        searchVariable="contains"
                        noFiltersTitle="All Bookings"
                    />
                </Grid>
            </Grid>
        );
    }
}

const enquiryColumns = [
    {
        label: 'Ref',
        propertyPath: 'LegacyKey',
        renderCell: (row, value) => (
            <Button href={PAGE_ENQUIRIES + row.ID} variant="link-orange">
                {value}
            </Button>
        )
    },
    {
        label: 'Deceased Name',
        propertyPath: 'Deceased.Surname',
        renderCell: row => (
            <span>{joinDefined([row.Deceased.FirstName, row.Deceased.MiddleName, row.Deceased.Surname], ' ')}</span>
        )
    },
    {
        label: 'Booking Date',
        propertyPath: 'Created',
        renderCell: row => <span>{shortDateFromString(row.Created)}<br />{niceTimeFromString(row.Created)}</span>
    },
    {
        label: 'Booking Type',
        propertyPath: 'EnquiryType'
    },
    {
        label: 'Applicant',
        propertyPath: 'Client.Surname',
        renderCell: row => {
            const applicant = !row.ClientSameAsEnquirer ? row.Client : row.Enquirer;
            return (
                <span>{!row.EnquiryByBusiness
                    ? joinDefined([applicant.FirstName, applicant.MiddleName, applicant.Surname], ' ')
                    : row.Business.Name}
                    <br />
                    {prettyPhone(!row.EnquiryByBusiness ? joinDefined([applicant.PrimaryNumber, applicant.SecondaryNumber], ' / ') : row.Business.Phone, false)}
                </span>
            );
        }
    },
    {
        label: 'Status',
        renderCell: row => {
            const hasOrder = (row.CremationOrder.ID > 0 && !row.CremationOrder.CremationCancelled && row.CremationOrder)
                || (row.PlaqueOrder.ID > 0 && !row.PlaqueOrder.Cancelled && row.PlaqueOrder);
            return hasOrder ? (
                <Button
                    href={(row.CremationOrder.ID > 0 && PAGE_CREMATIONS + hasOrder.LegacyKey + `/${hasOrder.ID}`) ||
                        (row.PlaqueOrder.ID > 0 && PAGE_PLAQUES + hasOrder.LegacyKey + `/${hasOrder.ID}`)}
                    variant="link-orange"
                >
                    {hasOrder.LegacyKey}
                </Button>
            ) : (!!row.Quotes.length ? (
                    row.Quotes.find(e => !!e.Accepted)
                        ? 'Accepted'
                        : row.Quotes.find(e => !!e.RespondedDate)
                            ? 'Declined'
                            : row.Quotes.find(e => !!e.Released)
                                ? 'Released'
                                : 'Draft'
                ) : (
                    moment().subtract(2, 'days').isBefore(row.Created)
                        ? 'New'
                        : moment().subtract(2, 'days').isAfter(row.Created) && (row.CremationOrder.ID < 1 || row.PlaqueOrder.ID < 1)
                            ? 'Stale'
                            : ''
                )
            ) || '';
        }
    },
    {
        label: '# Quotes',
        renderCell: row => <span>{row.Quotes.length}</span>
    },
    {
        label: 'Quote Amount',
        renderCell: row => (
            <span>
                {(row.Quotes.length &&
                        prettyPrice(
                            (row.Quotes.find(e => !!e.Accepted) && row.Quotes.find(e => !!e.Accepted).CalcQuoteTotal) ||
                            (row.Quotes.find(e => !!e.RespondedDate) &&
                                row.Quotes.find(e => !!e.RespondedDate).CalcQuoteTotal) ||
                            (row.Quotes.find(e => !!e.Released) && row.Quotes.find(e => !!e.Released).CalcQuoteTotal) ||
                            row.Quotes[0].CalcQuoteTotal
                        )) ||
                    ''}
            </span>
        )
    }
];

export default withErrorBoundary(compose(withRouter, withStyles({}))(EnquiryListing), { fallback: ErrorFallback });

